/**
 * 浏览器判断
 * */

// 判断是否为360极速浏览器
export const is360se = () => {
  const where = 'suffixes'
  const value = 'dll'
  const name = 'description'
  const nameReg = /fancy/
  const mimeTypes = window.navigator.mimeTypes
  for (const i in mimeTypes) {
    if (mimeTypes[i][where] === value) {
      if (nameReg.test(mimeTypes[i][name])) return false
    }
  }
  return true
}

// 获取浏览器类型
export const myBrowser = () => {
  const userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  const isOpera = userAgent.indexOf('Opera') > -1 // 判断是否Opera浏览器
  const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera // 判断是否IE浏览器
  const isEdge = userAgent.indexOf('Edge') > -1 || userAgent.indexOf('Edg') > -1 // 判断是否Edge浏览器
  const isSE = userAgent.toLowerCase().indexOf('se 2.x') > -1 // 判断是否搜狐浏览器
  const isFF = userAgent.indexOf('Firefox') > -1 // 判断是否Firefox浏览器
  const isQQ = userAgent.indexOf('QQBrowser') > -1 // 判断是否QQ浏览器
  const isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1 // 判断是否Safari浏览器
  const isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1 // 判断Chrome浏览器

  if (isIE) {
    /* eslint-disable */
    return 'IE';
    // const reIE = new RegExp('MSIE (\\d+\\.\\d+);');
    // reIE.test(userAgent);
    // const fIEVersion = parseFloat(RegExp['$1']);
    // if (fIEVersion === 7) {
    //   return 'IE7';
    // } else if (fIEVersion === 8) {
    //   return 'IE8';
    // } else if (fIEVersion === 9) {
    //   return 'IE9';
    // } else if (fIEVersion === 10) {
    //   return 'IE10';
    // } else if (fIEVersion === 11) {
    //   return 'IE11';
    // } else {
    //   return 'IE';
    // }
  }
  if (isOpera) {
    return 'Opera';
  }
  if (isEdge) {
    return 'Edge';
  }
  if (isSE) {
    return 'SE';
  }
  if (isFF) {
    return 'FF';
  }
  if (isQQ) {
    return 'QQ';
  }
  if (isSafari) {
    return 'Safari';
  }
  if (isChrome) {
    return 'Chrome';
  }
  if (is360se()) {
    return '360SE'
  }
}

// 获取谷歌浏览器版本
export const getChromeVersion = () => {
  const arr = navigator.userAgent.split(' ')
  let chromeVersion = ''
  for (let i = 0; i < arr.length; i++) {
    if (/chrome/i.test(arr[i])) {
      chromeVersion = arr[i]
    }
  }
  if (chromeVersion) {
    return Number(chromeVersion.split('/')[1].split('.')[0])
  } else {
    return false
  }
}
